import { SET_PROJECT, CLEAR_PROJECT } from "../constants";
import { Project } from "../../interfaces/Project";

export interface ProjectAction {
  type: string;
  project?: Project | any;
}

export const setProject = (project: Project | any) => {
  return {
    type: SET_PROJECT,
    project,
  };
};

export const clearProject = () => {
  return { type: CLEAR_PROJECT };
};
